(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('cart-timer')) return;

    const pad = (n) => String(n).padStart(2, '0');

    class CartTimer extends HTMLElement {
      connectedCallback() {
        const minutes = parseInt(this.dataset.minutes, 10) || 10;
        const key = 'cd-timer-end';
        let end = parseInt(sessionStorage.getItem(key), 10);
        if (!end || end < Date.now()) {
          end = Date.now() + minutes * 60 * 1000;
          sessionStorage.setItem(key, String(end));
        }
        const label = this.querySelector('[data-timer-label]');
        const tick = () => {
          let left = Math.max(0, Math.floor((end - Date.now()) / 1000));
          if (left === 0) {
            end = Date.now() + minutes * 60 * 1000;
            sessionStorage.setItem(key, String(end));
            left = minutes * 60;
          }
          const time = `${pad(Math.floor(left / 60))}:${pad(left % 60)}`;
          label.textContent = (this.dataset.text || 'Your cart will expire in {time}').replace('{time}', time);
        };
        tick();
        this.interval = setInterval(tick, 1000);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
      }
    }
    customElements.define('cart-timer', CartTimer);

    class CartExtras extends HTMLElement {
      connectedCallback() {
        this.setupDelivery();
        
        this.setupDiscount();
      }

setupDelivery() {
  const el = this.querySelector('.cd-delivery');
  if (!el) return;
  const label = el.querySelector('[data-delivery-label]');
  const days = parseInt(el.dataset.days, 10) || 3;

  const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;

  // Suma días hábiles (lunes a viernes). Si hoy es sábado o domingo,
  // el pedido se procesa el lunes y desde ahí se empieza a contar.
  const addBusinessDays = (from, n) => {
    const d = new Date(from);
    while (isWeekend(d)) d.setDate(d.getDate() + 1);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) added++;
    }
    return d;
  };

  const render = () => {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    const diff = Math.max(0, midnight - now);
    const hours = Math.floor(diff / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    const date = addBusinessDays(now, days);
    const lang = document.documentElement.lang || undefined;
    const dateStr = new Intl.DateTimeFormat(lang, { weekday: 'long', day: 'numeric', month: 'long' }).format(date);
    label.innerHTML = (el.dataset.text || 'Delivered on {date} if you order within {hours} and {minutes}')
      .replace('{date}', `<strong>${dateStr}</strong>`)
      .replace('{hours}', `<strong>${hours} ${hours === 1 ? 'hour' : 'hours'}</strong>`)
      .replace('{minutes}', `<strong>${mins} ${mins === 1 ? 'minute' : 'minutes'}</strong>`);
  };

  render();
  this.deliveryInterval = setInterval(render, 30000);
}
     

      setupDiscount() {
        const input = this.querySelector('[data-discount-input]');
        const btn = this.querySelector('[data-discount-apply]');
        if (!input || !btn) return;
        const apply = () => {
          const code = input.value.trim();
          if (!code) return;
          window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`;
        };
        btn.addEventListener('click', apply);
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            apply();
          }
        });
      }

     

      disconnectedCallback() {
        clearInterval(this.deliveryInterval);
      }
    }
    customElements.define('cart-extras', CartExtras);
  })();

  (() => {
    if (customElements.get('cart-whatsapp')) return;

    class CartWhatsapp extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.querySelector('[data-wa-open]').addEventListener('click', () => this.dialog.showModal());
        this.querySelector('[data-wa-close]').addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-wa-submit]').addEventListener('click', () => this.submit());
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.dialog.close();
        });
        // Evita que Enter envíe el formulario del carrito
        this.dialog.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
            e.preventDefault();
            this.submit();
          }
        });
      }

      buildMessage() {
        const cart = JSON.parse(this.querySelector('[data-cart-json]').textContent);
        const fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: cart.currency,
        });
        const intro = this.dataset.message || 'Hola, quiero realizar un pedido de este producto:';

        const items = cart.items.map((item, i) => {
          const variant = item.variant_title && item.variant_title !== 'Default Title' ? ` (${item.variant_title})` : '';
          const link = `${window.location.origin}${item.url.split('?')[0]}`;
          return `${i + 1}. *${item.product_title}*${variant}\n   Cantidad: ${item.quantity}\n   Precio: ${fmt.format(item.final_line_price / 100)}\n   ${link}`;
        });

        const customer = [...this.querySelectorAll('[data-field]')]
          .map((f) => [f.dataset.label, f.value.trim()])
          .filter(([, value]) => value)
          .map(([label, value]) => `${label}: ${value}`);

        return [
          intro,
          '',
          items.join('\n\n'),
          '',
          `*Total: ${fmt.format(cart.total_price / 100)}*`,
          '',
          '*Datos del cliente*',
          customer.join('\n'),
        ].join('\n');
      }

      submit() {
        const fields = [...this.querySelectorAll('[data-field]')];
        for (const field of fields) {
          if (!field.reportValidity()) return;
        }
        const number = (this.dataset.number || '').replace(/\D/g, '');
        const url = `https://wa.me/${number}?text=${encodeURIComponent(this.buildMessage())}`;
        const win = window.open(url, '_blank');
        if (!win) window.location.href = url;
        this.dialog.close();
      }
    }
    customElements.define('cart-whatsapp', CartWhatsapp);
  })();

(() => {
  if (window.__cdBubbleSync) return;
  window.__cdBubbleSync = true;

  async function syncBubble() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      const { item_count: count } = await res.json();
      const isEmpty = !count;

      document.querySelectorAll('.cart-bubble').forEach((bubble) => {
        bubble.classList.toggle('visually-hidden', isEmpty);
        bubble.hidden = isEmpty;
        bubble.style.display = isEmpty ? 'none' : '';

        const countEl = bubble.querySelector('.cart-bubble__text-count');
        if (countEl) {
          countEl.classList.toggle('hidden', isEmpty);
          countEl.textContent = isEmpty ? '' : count > 99 ? '99+' : count;
        }
      });
    } catch (e) {
      console.error('No se pudo sincronizar el contador del carrito', e);
    }
  }

  let timer;
  const debouncedSync = () => {
    clearTimeout(timer);
    timer = setTimeout(syncBubble, 150);
  };

  // Al cargar y al volver con "atrás" (bfcache)
  syncBubble();
  window.addEventListener('pageshow', syncBubble);

  // Cada vez que el drawer cambia (se elimina o agrega un producto)
  const watch = () => {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return false;
    new MutationObserver(debouncedSync).observe(drawer, { childList: true, subtree: true });
    return true;
  };
  if (!watch()) document.addEventListener('DOMContentLoaded', watch);
})();
  } catch(e) { console.error(e); }
})();

})();
